module.exports = {"baseUrl":"http://api.xkji.cn","loginbg":"https://hysq.xkji.cn/admin/images/bg.png","logo":"https://wq.xkji.cn/attachment/images/global/MP6lLGlVm17P2Wz63IcPHLDhdb3jCB.png","ptName":"新锐短信","dbbq":"<div style='margin-top:5px; '>Powered by KingMin <br><a href='https://xr.xkji.cn' class='el-link el-link--primary' target='_blank'>新锐云提供技术服务</a><div>","wddz":"https://bbs.xkji.cn","tpsc":"https://sms.xkji.cn/imgs/pcsctp.php"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 20